import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { GettingStartedFacade } from '@core/getting-started-legacy';
import type { GettingStartedSubtask } from '@core/getting-started-types';

import { WalkthroughState } from '../types';

@Injectable({ providedIn: 'root' })
export class WalkthroughNavigationHelperService {
  private readonly router = inject(Router);
  private readonly gettingStartedFacade = inject(GettingStartedFacade);

  public handleWalkthroughState(
    state: WalkthroughState,
    subtask: GettingStartedSubtask,
    cancelledPath: string[],
    clearDialog: boolean = false,
    clearJobEditor: boolean = false,
  ): void {
    if (state === WalkthroughState.Active) this.gettingStartedFacade.setSubtaskInProgress(subtask);
    if (state === WalkthroughState.Canceled) {
      if (clearDialog) this.clearDialogAndOpenDrawer(cancelledPath);
      else if (clearJobEditor) this.clearJobEditorAndOpenDrawer(cancelledPath);
      else this.navigateAndOpenDrawer(cancelledPath);
    }
  }

  public navigateAndOpenDrawer(path: string[]): void {
    this.router.navigate(path).then(() => this.openDrawer());
  }

  public clearDialogAndOpenDrawer(path: string[]): void {
    this.router.navigate([{ outlets: { dialog: null, 'job-editor': null } }]).then(() => {
      this.navigateAndOpenDrawer(path);
    });
  }

  public clearJobEditorAndOpenDrawer(path: string[]): void {
    this.router.navigate([{ outlets: { 'job-editor': null } }]).then(() => {
      this.navigateAndOpenDrawer(path);
    });
  }

  public openDrawer(): void {
    this.router.navigate([{ outlets: { 'getting-started-outlet': ['drawer', 'open'] } }]);
  }
}
